import { gql } from '@apollo/client'

export const GET_ORDER_RECOMMENDED_SHIPPINGS = gql`
  query GetOrderRecommendedShippings($orderNumber: String!, $shippingType: String) {
    order(number: $orderNumber) {
      id
      recommendedShippings(shippingType: $shippingType) {
        id
        quantity
        totalPrice
        vehicleType {
          id
          name
          weightLimit
        }
      }
    }
  }
`
